









































































































































































































import { FactureFournisseurApi } from "../api/FactureFournisseurApi";
import ConfirmSuppression from "../core/Modals/ConfirmSuppression";
import ExportButton from "../core/UI/ExportButton.vue";
import Pagination from "../core/UI/Pagination.vue";
import PerPage from "../core/UI/PerPage.vue";
import FactureFournisseurListFilters from "./FactureFournisseurListPartials/FactureFournisseurListFilters.vue";
import AutoRefresh from "../core/Table/AutoRefresh.vue";
import FactureFournisseurModal from "./FactureFournisseurModal.vue";
import { Routes } from "../utils/Routes";
import { FactureFournisseur } from "../models/FactureFournisseur";
import { Contact } from "../models/Contact";

export default {
    name: "FactureFournisseurList",
    components: {
        ExportButton,
        Pagination,
        PerPage,
        FactureFournisseurListFilters,
        AutoRefresh,
        FactureFournisseurModal,
    },
    data() {
        return {
            factures: [],
            totalHt: 0,
            totalTva: 0,
            FactureFournisseurApi: new FactureFournisseurApi(),
            currentPage: 1,
            totalPages: 1,
            itemsPerPage: 10,
            loading: false,
            filters: {},
            sort: "",
            factureFournisseurModal: {
                factureFournisseurId: null,
                isNew: false,
                forceEditing: false,
            },
        };
    },
    created() {
        this.loadPage(this.currentPage);
    },
    methods: {
        loadPage(page, hideLoading = false) {
            let self = this;
            let params = {
                limit: self.itemsPerPage,
                page: page,
                include: "files",
                sort: this.sort,
            };

            params = _.assign(params, self.filters);
            self.loading = !hideLoading;

            return self.FactureFournisseurApi.getAll(params)
                .then(function (response) {
                    let { data, metadata, paginator } = response;

                    self.factures = data;
                    self.totalPages = paginator.total_pages;
                    self.currentPage = paginator.current_page;
                    self.totalHt = metadata.montant_total_ht;
                    self.totalTva = metadata.montant_total_tva;

                    return self.factures;
                })
                .catch(function (error) {
                    self.factures = [];
                })
                .finally(function () {
                    self.loading = false;
                });
        },
        getFactures() {
            return this.loadPage(this.currentPage);
        },
        refreshFactures() {
            if (!this.loading) {
                this.loadPage(this.currentPage, true);
            }
        },
        updateFilters(filters): void {
            this.filters = filters;
            this.loadPage(1);
        },
        updateSort(sort): void {
            this.sort = sort;
            this.loadPage(1);
        },
        getExportParams() {
            return _.assign({ sort: this.sort }, this.filters);
        },
        editFacture(facture) {
            this.factureFournisseurModal.isNew = false;
            this.factureFournisseurModal.forceEditing = true;
            this.factureFournisseurModal.factureFournisseurId = facture.id;
        },
        onFactureFournisseurModalClose() {
            this.factureFournisseurModal.factureFournisseurId = null;
            this.factureFournisseurModal.forceEditing = false;
            this.factureFournisseurModal.isNew = false;
            this.refreshFactures(false);
        },
        deleteFacture(facture) {
            let self = this;
            ConfirmSuppression.demanderRaison(
                "Voulez vous supprimer cette facture&nbsp;?"
            ).then(function (raison) {
                if (raison === null) {
                    return;
                }
                self.FactureFournisseurApi.delete(facture.id, raison)
                    .then(function () {
                        self.getFactures();
                        swal(
                            "La facture a bien été supprimée !",
                            "",
                            "success"
                        );
                    })
                    .catch(function (error) {
                        let data =
                            (error.response && error.response.data) || {};
                        swal(
                            "Suppression impossible",
                            data.message ||
                                (data.error && data.error.message) ||
                                "",
                            "error"
                        );
                    });
            });
        },
        // UI
        addContactUrl(facture: FactureFournisseur): string {
            if (facture.invoice_issuer) {
                return (
                    Routes.new_contact +
                    "?nom=" +
                    facture.invoice_issuer +
                    "&type=" +
                    Contact.EType.Fournisseur
                );
            }
        },
        showMailInfo() {
            swal({
                title: "Import de documents",
                text:
                    "Les factures doivent être transférées par mail à l'adresse <a href='mailto:" +
                    window.documentMail +
                    "'>" +
                    window.documentMail +
                    "</a>" +
                    "<br/>" +
                    "Format pdf uniquement, une facture par fichier, plusieurs factures dans le même mail possible.",
                type: "info",
                showCancelButton: false,
                confirmButtonClass: "btn btn-success",
                confirmButtonText: "OK",
            });
        },
    },
    watch: {
        itemsPerPage: function () {
            this.loadPage(1);
        },
        filters: {
            deep: true,
            handler: function () {
                this.loadPage(1);
            },
        },
        sort: function () {
            this.loadPage(1);
        },
    },
};
